import { useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';

function Profile() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [editable, setEditable] = useState(false);
  const [error, setError] = useState(false);
  const [isValid, setIsValid] = useState({});

  useEffect(() => {
    userInfo();
  }, []);

  const updateUserInfo = async (e) => {
    e.preventDefault();
    if (!(firstName && lastName && email && phoneNumber)) {
      setError(true);
      return;
    }
    if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
      setIsValid({ field: 'email' });
      return;
    }
    if (phoneNumber.length != 10) {
      setIsValid({ field: 'phoneNumber' });
      return;
    }
    localStorage.setItem(
      'loggedInUserData',
      JSON.stringify({ firstName, lastName, email, phoneNumber })
    );
    setEditable(false);
    setIsValid({});
  };

  const userInfo = () => {
    const { firstName, lastName, email, phoneNumber } = JSON.parse(
      localStorage.getItem('loggedInUserData')
    );

    setFirstName(firstName);
    setLastName(lastName);
    setEmail(email);
    setPhoneNumber(phoneNumber);
    if (editable) setEditable(false);
  };

  return (
    <div className='su-dashboard pl-4 pr-4 pb-5'>
      <h2 className='pt-5'>Profile</h2>

      {!editable ? (
        <div>
          <div className='pt-4 h5 w-50'>
            <Container>
              <Row>
                <Col xs={4}>First Name:</Col>
                <Col>{firstName}</Col>
              </Row>
            </Container>

            <Container className='pt-4'>
              <Row>
                <Col xs={4}>Last Name:</Col>
                <Col>{lastName}</Col>
              </Row>
            </Container>

            <Container className='pt-4'>
              <Row>
                <Col xs={4}>Email:</Col>
                <Col>{email}</Col>
              </Row>
            </Container>

            <Container className='pt-4'>
              <Row>
                <Col xs={4}>Phone Number:</Col>
                <Col>{phoneNumber}</Col>
              </Row>
            </Container>
          </div>

          <div className='pt-4 w-25'>
            <button
              className='btn button-primary btn-rounded btn-block btn-md w-auto mx-auto'
              onClick={() => setEditable(!editable)}
            >
              Update Profile
            </button>
          </div>
        </div>
      ) : (
        <div>
          <div className='pt-4 h5 w-50'>
            <Form>
              <Form.Group controlId='firstName' className='mb-3'>
                <div className='d-flex justify-content-between'>
                  <span className='my-auto'>First Name:</span>
                  <Form.Control
                    type='text'
                    size='md'
                    className='input-rounded border w-75'
                    placeholder='First Name'
                    defaultValue={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
                {error && !firstName && (
                  <Form.Text className='small help-block text-danger text-center'>
                    FirstName is required
                  </Form.Text>
                )}
              </Form.Group>

              <Form.Group controlId='lastName' className='mb-3'>
                <div className='d-flex justify-content-between'>
                  <span className='my-auto'>Last Name:</span>
                  <Form.Control
                    type='text'
                    size='md'
                    className='input-rounded border w-75'
                    placeholder='Last Name'
                    defaultValue={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
                {error && !lastName && (
                  <Form.Text className='small help-block text-danger text-center'>
                    LastName is required
                  </Form.Text>
                )}
              </Form.Group>

              <Form.Group controlId='email' className='mb-3'>
                <div className='d-flex justify-content-between'>
                  <span className='my-auto'>Email:</span>
                  <Form.Control
                    type='email'
                    size='md'
                    className='input-rounded border w-75'
                    pattern='/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/'
                    placeholder='Email'
                    defaultValue={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                {error && !email && (
                  <Form.Text className='small help-block text-danger text-center'>
                    Email is required
                  </Form.Text>
                )}
                {isValid.field === 'email' && (
                  <Form.Text className='small help-block text-danger text-center'>
                    Please enter a valid Email address
                  </Form.Text>
                )}
              </Form.Group>

              <Form.Group controlId='phoneNumber' className='mb-3'>
                <div className='d-flex justify-content-between'>
                  <span className='my-auto'>Phone Number:</span>
                  <Form.Control
                    type='number'
                    size='md'
                    className='input-rounded border w-75'
                    placeholder='Phone Number'
                    defaultValue={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </div>
                {error && !phoneNumber && (
                  <Form.Text className='small help-block text-danger text-center'>
                    Phone Number is required
                  </Form.Text>
                )}
                {isValid.field === 'phoneNumber' && (
                  <Form.Text className='small help-block text-danger text-center'>
                    Please enter a valid Phone Number
                  </Form.Text>
                )}
              </Form.Group>

              <div className='mt-4 d-flex justify-content-around'>
                <Button
                  type='submit'
                  className='btn button-primary btn-rounded'
                  onClick={updateUserInfo}
                >
                  Save Profile
                </Button>

                <Button
                  className='btn button-primary btn-rounded'
                  onClick={userInfo}
                >
                  Cancel
                </Button>
              </div>
            </Form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Profile;
